import React, { FunctionComponent, memo } from 'react';
import { Grid } from '@material-ui/core';
import AccessoryItem from '../accessoryItem/AccessoryItem';
import { GetFeatureChildren_featureChildren } from '../../../../../../graphql/queries/__generated__/GetFeatureChildren';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

export interface IAccessoriesListProps {
  /**
   * List of accessories used when searched is active
   */
  accessories: GetFeatureChildren_featureChildren[];
  /**
   * Event used to handle logic on selecting the accessory
   */
  onClick?: (name: string) => void;
  /** Used to decide if the checkbox is displayed for accessories */
  isSelectable?: boolean;
  /** Flag to signal the list is rendered in a modal */
  inModal?: boolean;
}

const AccessoriesList: FunctionComponent<IAccessoriesListProps> = memo(
  ({ accessories, onClick, isSelectable = true, inModal }) => {
    const { optimisticSelectedFeatures } = useCustomizeCarContext();

    return (
      <Grid container={true} spacing={2}>
        {accessories?.map(accessory => (
          <AccessoryItem
            key={accessory.code}
            accessory={accessory}
            isSelected={optimisticSelectedFeatures?.includes(accessory.code.toLowerCase())}
            onClick={onClick}
            isSelectable={isSelectable}
            inModal={inModal}
          />
        ))}
      </Grid>
    );
  },
);

export default AccessoriesList;
